import {Card, CardContent, Checkbox, FormControlLabel, Grid, TextField} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";
import {DateField} from "~/apps/core/ui/DateField";
import {ActivityKindSelect} from "~/apps/packages/passes/components/PassForm/ActivityKindSelect";
import {Type, Values} from "./PassForm"
import React, {useEffect} from "react";
import {FileCard} from "~/apps/core/ui/FileCard";
import {Box} from "@mui/system";


export type AdmissionFormCardProps = {
    types: Type[]
}


export const AdmissionFormCard = (props: AdmissionFormCardProps) => {
    const {types} = props;
    const {control, setValue, errors} = useFormContext<Values>();


    // validate when include car
    useEffect(() => {
        if (!types.includes("PEDESTRIAN")) {
            setValue("accessZone3", false, {shouldValidate: true});
        }
    }, [types])

    return (
        <Card>
            <CardContent>
                <Grid container direction="column" spacing={2} wrap="nowrap">
                    <Grid item>
                        <Controller
                            name="passDate"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <DateField
                                    label="Дата допуска"
                                    fullWidth
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="paragraph"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <ActivityKindSelect
                                    label="Пункт распоряжения"
                                    fullWidth
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                        <Box marginTop="12px">
                            <FileCard
                                type="download"
                                name="Распоряжения правительства"
                                format="PDF"
                                size={97166}
                                uri="/docs/Распоряжение правительства 907.pdf"
                            />
                        </Box>
                    </Grid>
                    <Grid item>
                        <Controller
                            name="companyActivityKind"
                            control={control}
                            rules={{
                                // required: true,
                                validate: value => (value || "").replace(/\s*/g, '').length > 0 || "Обязательно для заполнения"
                            }}
                            render={({onChange, value, name, ref}) => (
                                <TextField
                                    label="Цель посещения"
                                    placeholder="Опишите цель посещения"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    inputProps={{maxLength: 255}}
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item container direction="column" spacing={1}>
                        <Grid item>
                            <Controller
                                name="accessZone1"
                                control={control}
                                render={({onChange, value}) => (
                                    <FormControlLabel
                                        disabled={true}
                                        control={<Checkbox checked={value} onChange={e => {
                                            onChange(e.target.checked)
                                        }}/>}
                                        label="Зона 1 (дорога, офисы в порту)"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item>
                            <Controller
                                name="accessZone2"
                                control={control}
                                render={({onChange, value}) => (
                                    <FormControlLabel
                                        control={<Checkbox checked={value} onChange={e => {
                                            onChange(e.target.checked)
                                        }}/>}
                                        label="Зона 2 (причалы)"
                                    />
                                )}
                            />
                        </Grid>
                        {types.includes("PEDESTRIAN") && <Grid item>
                            <Controller
                                name="accessZone3"
                                control={control}
                                render={({onChange, value}) => (
                                    <FormControlLabel
                                        disabled={!types.includes("PEDESTRIAN")}
                                        control={<Checkbox checked={value} onChange={e => {
                                            onChange(e.target.checked)
                                        }}/>}
                                        label="Зона 3 (заграничные суда)"
                                    />
                                )}
                            />
                        </Grid>}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
